import { useEffect, useState } from 'react';
import { StatusOption } from 'shared/types/general';
import { equipmentApi } from '../api/equipmentApi';

export const useEquipmentIvdrOptions = () => {
  const [ivdrOptions, setIvdrOptions] = useState<StatusOption[]>([]);

  useEffect(() => {
    equipmentApi.getIvdrOptions().then(setIvdrOptions);
  }, []);

  return { ivdrOptions };
};
